<template>
<div class="">
  <slider :style="{height: '200px'}">
    <div class="p2222">
      <p>
        11111111
      </p>
      <p>
        222222222
      </p>
      <p>
        222222222
      </p>
      <p>
        222222222
      </p>
      <p>
        222222222
      </p>
      <p>
        222222222
      </p>
      <p>
        222222222
      </p>
      <p>
        222222222
      </p>
      <p>
        11111111
      </p>
      <p>
        222222222
      </p>
      <p>
        222222222
      </p>
      <p>
        222222222
      </p>
      <p>
        222222222
      </p>
      <p>
        222222222
      </p>
      <p>
        222222222
      </p>
      <p>
        222222222
      </p>

      <p>
        11111111
      </p>
      <p>
        222222222
      </p>
      <p>
        222222222
      </p>
      <p>
        222222222
      </p>
      <p>
        222222222
      </p>
      <p>
        222222222
      </p>
      <p>
        222222222
      </p>
      <p>
        222222222
      </p>
      <p>
        11111111
      </p>
      <p>
        222222222
      </p>
      <p>
        222222222
      </p>
      <p>
        222222222
      </p>
      <p>
        222222222
      </p>
      <p>
        222222222
      </p>
      <p>
        222222222
      </p>
      <p>
        222222222
      </p>
      <p>
        11111111
      </p>
    </div>
  </slider>

  <slider :style="{height: '100px'}">
    <div style="width:1000px;height:100px;text-align:left">
sddsfsdfsdfdsfdssddssdfdsdsfdsfsd
    </div>
  </slider>
</div>

</template>

<script>
import Slider from './slider'


export default {
  name: 'sliderdemo',
  components: {
    Slider
  },
  created() {

  },
  data() {
    return {

    }
  }
}
</script>



// WEBPACK FOOTER //
// demo.vue?054d5b52